/**
 * DS0.1: slot da marca CORTEX no login e na sidebar, só com texto. O logo não é recomposto com fonte aproximada: os
 * mestres de marca entram numa etapa própria e trocam este slot pelos derivados listados em public/marca/README.md.
 */
export const NOME_MARCA = 'CORTEX';

export function MarcaCortex({ grande = false }: { grande?: boolean }) {
  return (
    <span data-slot-marca="logo" className={`font-mono font-semibold tracking-widest text-acento-texto ${grande ? 'text-xl' : 'text-base'}`}>
      {NOME_MARCA}
    </span>
  );
}
